import React, { useState } from "react";
import { Route } from "react-router-dom";

import WorkOrderComplete from "../workOrderActions/workOrderComplete";
import WorkOrderIncomplete from "../workOrderActions/workOrderIncomplete";
import WorkOrderFollowUp from "../workOrderActions/workOrderFollowUp";
import Technician from "../technicians/technicians";
import Workorderdetails from "../technicians/workorder/workorderdetails";

function LabourerRoutes() {
    return (
        <>
            <Route exact path="/" component={Technician} />
            <Route exact path="/workorderdetails/:workOrderNumber" component={Workorderdetails} />
            <Route exact path="/workorderdetails/:workOrderNumber/complete" component={WorkOrderComplete} />
            <Route exact path="/workorderdetails/:workOrderNumber/incomplete" component={WorkOrderIncomplete} />
            <Route exact path="/workorderdetails/:workOrderNumber/followUp" render={() => <WorkOrderFollowUp />} />
        </>
    );
}

export default LabourerRoutes;
